function initializeBlogStorageIndex(sectionId) {
  const section = document.querySelector(`[data-blog-storage-index="${sectionId}"]`);
  if (!section || section.dataset.initialized === 'true') return;

  section.dataset.initialized = 'true';
  renderBlogStorageIndex(section);
}

async function renderBlogStorageIndex(section) {
  const body = section.querySelector('[data-blog-storage-list-body]');
  const pagination = section.querySelector('[data-blog-storage-pagination]');
  const pagesWrap = pagination ? pagination.querySelector('.pages') : null;
  const prevLink = pagination ? pagination.querySelector('.prev a') : null;
  const nextLink = pagination ? pagination.querySelector('.next a') : null;
  const perPage = Number(section.dataset.itemsPerPage || 10);

  if (!body || !pagination || !pagesWrap || !prevLink || !nextLink) return;

  const items = await collectStorageItems(section);
  const sortedItems = items.sort((a, b) => {
    const dateDiff = Number(b.timestamp || 0) - Number(a.timestamp || 0);
    if (dateDiff !== 0) return dateDiff;
    return Number(a.order || 0) - Number(b.order || 0);
  });

  if (sortedItems.length === 0) {
    body.innerHTML = '<div class="empty__content">표시할 콘텐츠가 없습니다.</div>';
    pagination.classList.add('hidden');
    return;
  }

  let currentPage = 1;
  const totalPages = Math.ceil(sortedItems.length / perPage);

  const renderRows = () => {
    const startIndex = (currentPage - 1) * perPage;
    const pageItems = sortedItems.slice(startIndex, startIndex + perPage);

    body.innerHTML = '';

    pageItems.forEach((item, index) => {
      const row = document.createElement('div');
      row.className = 'storage__content';

      const link = document.createElement('a');
      link.href = item.url;

      const number = document.createElement('div');
      number.className = 'storage__number';
      number.textContent = startIndex + index + 1;

      const title = document.createElement('div');
      title.className = 'storage__title';
      title.textContent = item.title;

      link.append(number, title);
      row.append(link);
      body.append(row);
    });
  };

  const renderPageButtons = () => {
    pagesWrap.innerHTML = '';

    for (let page = 1; page <= totalPages; page += 1) {
      const button = document.createElement('button');
      button.className = `blog-storage-index-pagination-btn${page === currentPage ? ' active' : ''}`;
      button.type = 'button';
      button.dataset.page = String(page);
      button.textContent = page;
      pagesWrap.append(button);
    }
  };

  const updateControls = () => {
    prevLink.classList.toggle('disabled', currentPage === 1);
    nextLink.classList.toggle('disabled', currentPage === totalPages);
    pagination.classList.toggle('hidden', totalPages <= 1);
  };

  const render = () => {
    renderRows();
    renderPageButtons();
    updateControls();
  };

  prevLink.addEventListener('click', (event) => {
    event.preventDefault();
    if (currentPage === 1) return;
    currentPage -= 1;
    render();
  });

  nextLink.addEventListener('click', (event) => {
    event.preventDefault();
    if (currentPage === totalPages) return;
    currentPage += 1;
    render();
  });

  pagesWrap.addEventListener('click', (event) => {
    const button = event.target.closest('[data-page]');
    if (!button) return;

    const targetPage = Number(button.dataset.page);
    if (!targetPage || targetPage === currentPage) return;

    currentPage = targetPage;
    render();
  });

  render();
}

async function collectStorageItems(section) {
  const items = [
    ...readStorageItems(section.querySelector('.blog-storage-index__blog-data')),
    ...readStorageItems(section.querySelector('.blog-storage-index__manual-data'))
  ];

  let nextPageUrl = section.querySelector('.blog-storage-index__blog-data')?.dataset.nextPage;
  const visitedUrls = new Set();

  while (nextPageUrl && !visitedUrls.has(nextPageUrl)) {
    visitedUrls.add(nextPageUrl);

    try {
      const response = await fetch(nextPageUrl);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextData = doc.querySelector('.blog-storage-index__blog-data');

      items.push(...readStorageItems(nextData));
      nextPageUrl = nextData?.dataset.nextPage;
    } catch (error) {
      console.warn('Storage 게시물 추가 페이지를 불러오지 못했습니다.', error);
      break;
    }
  }

  return items.filter((item) => item.url && item.title);
}

function readStorageItems(element) {
  if (!element) return [];

  try {
    const data = JSON.parse(element.textContent);
    return Array.isArray(data.items) ? data.items : [];
  } catch (error) {
    console.warn('Storage 목록 데이터를 읽지 못했습니다.', error);
    return [];
  }
}
